import buttonStyles from "../Button.module.scss";
import styles from "./Header.module.scss";
import iconStyles from "../Icon.module.scss";
import { useEffect, useRef, useState } from "react";

const Header = () => {
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive((prev) => !prev);

    const body = document.body;

    // Toggle 'stop' class
    body.classList.toggle("stop");

    // Simulate ::after opacity animation using a helper <style> element or CSS transitions
    const stopActive = body.classList.contains("stop");
    if (stopActive) {
      body.style.setProperty("--body-after-opacity", "1");
    } else {
      body.style.setProperty("--body-after-opacity", "0");
    }
  };

  const headerRef = useRef<HTMLElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const scrollThreshold = 400;

  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (!headerRef.current) return;

      if (scrollTop > scrollThreshold) {
        if (scrollTop > lastScrollTop) {
          // Scrolling down
          headerRef.current.style.transform = "translateY(-100%)";
        } else {
          // Scrolling up
          headerRef.current.style.transform = "translateY(0)";
        }
      } else {
        // Within threshold
        headerRef.current.style.transform = "translateY(0)";
      }

      lastScrollTop = scrollTop;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up
    };
  }, []);

  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (
        headerRef.current &&
        !headerRef.current.contains(e.target as Node) &&
        menuRef.current &&
        !menuRef.current.contains(e.target as Node)
      ) {
        setIsActive(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isActive]);

  return (
    <header ref={headerRef}>
      <a href="/" className={styles.logo}>
        <img src="logo.svg" alt="logo" />
      </a>
      <div
        ref={menuRef}
        className={`${styles.menu} ${isActive ? styles.active : ""}`}
      >
        <a href="/about-us">
          <div className={styles["menu-item"]}>About us</div>
        </a>
        <a href="/branches">
          <div className={styles["menu-item"]}>Branches in Europe</div>
        </a>
        <a href="/movements">
          <div className={styles["menu-item"]}>
            Reformed Evangelical Movement
          </div>
        </a>
        <a href="/service">
          <div className={styles["menu-btn"]}>
            Join our Sunday service
            <span className={`${iconStyles.icon} ${iconStyles.next}`}></span>
          </div>
        </a>
      </div>
      <div
        className={`${buttonStyles.btn} ${
          isActive ? buttonStyles.active : ""
        } ${styles["burger-menu"]}`}
        onClick={handleClick}
      >
        <span
          className={`${iconStyles.icon} ${styles.icon} ${
            isActive ? iconStyles.close : iconStyles.list
          }`}
        ></span>
      </div>
    </header>
  );
};

export default Header;
